import { render, staticRenderFns } from "./Video-2.vue?vue&type=template&id=41b0400b&scoped=true"
import script from "./Video-2.vue?vue&type=script&lang=js"
export * from "./Video-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b0400b",
  null
  
)

export default component.exports